<template>
	<!-- 预约查验-->
	<div class="page-container">
		<el-form :model="wmOrderForm" ref="ruleFormRef" :rules="rulesForm" class="form-panel" label-position="top"
			:validateOnRuleChange="false">
			<el-col :span="24">
				<div>
			<!-- 		<el-row class="title-panel">
						<el-col>
							<span class="title-text">查询条件</span>
						</el-col>
					</el-row> -->
					<el-row class="content-panel border-radius" id="boxDiv">
						<!-- 查询-start -->
           <el-row class="query-module">
						<el-row :gutter="5">
              <el-col :span="2" style="margin-top:10px;padding-left:15px">
								查询条件
							</el-col>
							<el-col :span="10">
								<el-form-item>
									<el-input size="small" placeholder="分拨提单号/分单订单号/HBL No."
										v-model="formData.deployPort">
									</el-input>
								</el-form-item>
							</el-col>
              <el-col :span="4">
								<el-form-item>
									<el-input size="small" placeholder="请输入验证码"
										v-model="formData.verificationCode">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" style="margin-top: 2px">
								<el-row>
									<el-button type="primary" size="small" class="el-button-search" plain @click="queryOrder">查询</el-button>
									<el-button type="primary" size="small" plain @click="resetForm">重置</el-button>
								</el-row>
							</el-col>
						</el-row>
          </el-row>
					</el-row>
				</div>
				<!-- 查询-end -->
				<!-- 查验预约-start -->

				<el-row class="panel-top">

					<el-col>
			     <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">查验预约</span>
                </el-col>
                </div>
           </el-row>
						<el-row class="content-panel">
							<el-col>
								<el-row :gutter="10">
									<el-col :span="24" class="blue-bg border-radius">
										<!-- 基本信息-查验-start -->
										<el-row>
										<el-row class="title-panel-external blue-bg">
											<div class="title-panel">
											<el-col>
											<span class="title-text">基本信息</span>
											</el-col>
											</div>
                    </el-row>

											<el-col>
												<el-row :gutter="15" class="content-panel blue-bg" style="margin:0">

													<el-col :span="4">
														<el-form-item label="船名:">
															<el-input size="mini" v-model="wmOrderForm.vesselNameEn"
																readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="4">
														<el-form-item label="航次:">
															<el-input size="mini" v-model="wmOrderForm.voyage" readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item label="仓位:">
															<el-input size="mini" v-model="wmOrderForm.locationCode"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item label="危险品:">
															<el-input size="mini" v-model="wmOrderForm.isHazardCn"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item label="件数:">
															<el-input size="mini" v-model="wmOrderForm.noOfPackage"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item label="毛重:">
															<el-input size="mini" v-model="wmOrderForm.grossWeight"
																readonly></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item label="体积:">
															<el-input size="mini" v-model="wmOrderForm.cube" readonly>
															</el-input>
														</el-form-item>
													</el-col>
													<el-col :span="4">
														<el-row>
															<el-form-item label="分单订单号:">
																<el-input size="mini" v-model="wmOrderForm.orderNo"
																	readonly>
																</el-input>
															</el-form-item>
														</el-row>
													</el-col>
												</el-row>
											</el-col>
											<!-- 基本信息-查验-end -->

									<!-- 		<el-col style="height:52.09px;">
											</el-col> -->
										</el-row>
									</el-col>
									<!-- 查验预约-end -->
							<!-- 		<el-col style="height:15px;"></el-col> -->
									<!-- 查验预约信息-begin -->
									<el-col :span="24" style="margin-top:10px; padding:0px">
										<el-row :span="12">
										<el-col :span="24">
											<el-row class="title-panel-external blue-bg" style="margin:0px">
                          <div class="title-panel">
                          <el-col>
                          <span class="title-text">查验预约信息</span>
                          </el-col>
                          </div>
                      </el-row>
												<!-- begin -->
                   <el-row :gutter="15" class="content-panel blue-bg" style="margin:0">
												<el-col>
													<el-row :gutter="10">
														<el-col :span="4">
															<el-form-item label="陪同状态:" prop="wmAppApmtListDto.accopySts">
																<el-select class="length_input" size="mini"
																	v-model="wmOrderForm.wmAppApmtListDto.accopySts" placeholder="请选择">
																	<el-option v-for="item in accopyStsList"
																		:key="item.key" :label="item.value"
																		:value="item.key">
																	</el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="预约日期:" prop="wmAppApmtListDto.apmtDatePeroid">
																<el-select class="length_input" size="mini"
																	v-model="wmOrderForm.wmAppApmtListDto.apmtDatePeroid"
																	placeholder="请选择">
																	<el-option v-for="item in appointmentDataList"
																		:key="item" :value="item.key"
																		:label="item.value">
																	</el-option>
																</el-select>

															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="收货人:" prop="wmAppApmtListDto.udf01">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.udf01">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="报关单位:" prop="wmAppApmtListDto.udf02">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.udf02">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="联系人:" prop="wmAppApmtListDto.contactUser">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.contactUser">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="4">
															<el-form-item label="联系人电话:" prop="wmAppApmtListDto.contactTel">
																<el-input size="mini" v-model="wmOrderForm.wmAppApmtListDto.contactTel">
																</el-input>
															</el-form-item>
														</el-col>

													</el-row>
												</el-col>
													<el-col>
													<hr style="border:1px solid #F0F0F0"></hr>
												</el-col>
												 <!-- 查验预约信息报单列表 -->
												<el-col>
													<el-row :gutter="10" v-for="(item,index) in wmOrderForm.wmAppApmListDetailList" :key="item.wmAppApmtListDetailId" >
														<el-col :span="4">
																<div class="el-form-item el-form-item--medium">
                                  <div>
                                  <span style="color:red"> * </span><span style="color: #606266;    line-height: 16px;">报关单号:</span>
                                </div>
                                <div class="el-input el-form-item__content el-input--mini">
<el-input size="mini"
																	v-model="item.declarationNo" @change="changeDeclarationNo" >
																</el-input>
                                </div>

                                </div>
														</el-col>
														<el-col :span="4">
															<el-form-item label="其他单号:">
																<el-input size="mini" v-model="item.otherNo" >
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item label="件数:">
																<el-input type="number" size="mini" v-model="item.qty" @blur="changeNegativeNumber($event)" >
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item label="重量:">
																<el-input type="number" size="mini" v-model="item.weight" @blur="changeNegativeNumber($event)">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item label="体积:">
																<el-input type="number"  size="mini" v-model="item.volume" @blur="changeNegativeNumber($event)">
																</el-input>
															</el-form-item>
														</el-col>
														<el-col :span="3">
															<el-form-item label="最后修改时间:" hidden="true">
																<el-input size="mini" v-model="item.lastModifyTime">
																</el-input>
															</el-form-item>
														</el-col>
                            <el-col :span="4">
                              <el-form-item label="     ">
                                <el-button type="primary" size="small" plain @click="addWmAppApmListDetailList" v-if="index === wmOrderForm.wmAppApmListDetailList.length-1">增加</el-button>
															             <el-button type="danger" size="mini" @click="removeWmAppApmListDetailList(index)" :disabled="wmOrderForm.wmAppApmListDetailList.length === 1">删除</el-button>

															</el-form-item>

                            </el-col>
													</el-row>
												</el-col>
                	</el-row>
											</el-col>
											<!-- 查验预约信息-end -->
											<el-col style="height:52.09px;"></el-col>
										</el-row>
									</el-col>
						    </el-row>
             	</el-col>
          	</el-row>
			    </el-col>
				</el-row>
			</el-col>

			<!-- 箱信息-end -->

			<div style="text-align: right">

				<el-button :plain="false" :type="wmOrderForm.isOverApmtDatePeroid?'primary':'info'" size="mini" @click="submitOrder" :disabled="!wmOrderForm.isOverApmtDatePeroid">提交</el-button>
				<el-button type="primary" size="mini" @click="closeTab">关闭</el-button>

			</div>
		</el-form>
	</div>
</template>

<script>
import { queryWmOrderAppointment, submitAppointment } from "@/api/appointment";

import { bookingFormRules } from "@/rules/booking_rules";
import { queryDictRows } from "@/api/commonService";

import { ebCtnValidate } from "@/rules/ebCtnRules";
import { isArray } from "@/utils/validate";
export default {
  name: "bookingAdd",
  components: {},
  data() {
    return {
      boxVisible: true,
      moreInfoVisible: false,
      ebOrderForm: {
        mblNo: null,
        carrierName: null,
        vesselNameEn: null,
        voyage: null,
        polName: null,
        vgmVerifyDate: null,
      },
      //陪同状态
      accopyStsList: [],
      //预约日期
      appointmentDataList: [],
      //日期设置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      searchData: {
        startTime: null,
      },
      readonly: true,
      wmOrderForm: {
        isOverApmtDatePeroid: false,
        vesselNameEn: null,
        locationCode: "",
        voyage: null,
        orderNo: null,
        position: null,
        isHazard: null,
        isHazardCn: null,
        noOfPackage: null,
        grossWeight: null,
        cube: null,
        accopySts: "ACC",
        apmtDatePeroid: "",
        udf01: null,
        udf02: null,
        udf03: "",
        contactUser: null,
        contactTel: null,
        declarationNo: null,
        otherNo: null,
        qty: null,
        weight: null,
        cube: null,
        wmOrderId: null,
        volume: null,
        wmAppApmtListDto: {
          accopySts: "ACC",
          apmtDate: "",
          apmtDatePeroid: "",
          apmtPeriod: "",
          contactTel: "",
          contactUser: "",
          driver: null,
          driverTel: null,
          udf01: "",
          udf02: "",
          udf03: "",
          vehicleCode: null,
          wmAppApmtListId: "",
          wmOrderId: "",
        },
        wmAppApmListDetailList: [
          {
            declarationNo: "",
            otherNo: "",
            qty: "",
            weight: "",
            volume: "",
            lastModifyTime: "",
          },
        ],
      },
      rulesForm: {
        "wmAppApmtListDto.apmtDatePeroid": [
          {
            required: true,
            message: "预约日期不能为空",
            trigger: ["blur", "change"],
          },
        ],
        "wmAppApmtListDto.udf01": [
          {
            required: true,
            message: "收货人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        "wmAppApmtListDto.udf02": [
          {
            required: true,
            message: "报关单位不能为空",
            trigger: ["blur", "change"],
          },
        ],
        "wmAppApmtListDto.contactUser": [
          {
            required: true,
            message: "联系人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        "wmAppApmtListDto.contactTel": [
          {
            required: true,
            message: "联系电话不能为空",
            trigger: ["blur", "change"],
          },
        ],
        declarationNo: [
          {
            required: true,
            message: "报关单号不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },

      manifestAddForm: {},
      bookingForm: {
        bookingNum: null,
        customerbusiness_num: null,
        bill_lading_num: null,
        payType: null,
        payer: null,
        pay_place: null,
        clause: null,
        sc: null,
        na: null,
        signing_method: null,
        signing_place: null,
        copies_chief: null,
        copies_deputy: null,
        contacts: null,
        contact_number: null,
        email: null,
        checkList: [],
        etd: null,
        customerNotes: null,
        feedbackNotes: null,
      },
      ebOrderInfoAndEbCtnInfo: {
        ebCtn: [],
        ebOrderId: "",
      },
      // 表格校验
      ebCtnRules: {},
      //搜索框
      formData: {
        deployPort: null,
        verificationCode: null
      },
      wmAppApmtListDto: [],
      //tab状态栏
      activeName: 0,
      // 表格数据
      ebCtnTableDataSource: [],
      // 表格设置
      ebCtnTableSettings: {
        height: 205,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeMe,
        ...this.$systemConfig.tableConfig,
      },
      cargoInfoForm: {
        checkList: [],
        shippingMark: "父向子传值", //唛头
        cargoDetail: null, //货物描述
        pieces: null,
        package: null,
        grossWeight: null, //毛重
        volume: null, //体积
        netWeight: null, //净重
        hsCode: null,
        cargoInfoArr: [0],
      },
    };
  },
  async created() {

    let self = this;
  },
  mounted() {
    let _this = this;
    _this.getSelectList();
    //接收订舱管理界面-VGM维护
    if (_this.$route.params.ebOrder !== undefined) {
      let ebOrder = _this.$route.params.ebOrder;
      _this.ebOrderForm = ebOrder;
      console.log("_this.$route.params.ebOrder:", ebOrder);
    }

    _this.ebCtnRules = ebCtnValidate();
    _this.resizeObserver = new ResizeObserver((entries) => {
      _this.$nextTick(() => {
        // if (this.boxVisible) {
        //   _this.$refs.boxInfoTableRef.resizeTo(
        //     entries[0].target.clientWidth - 19
        //   );
        // } else {
        //   _this.$refs.boxDetailTableRef.resizeTo(
        //     entries[0].target.clientWidth - 19
        //   );
        // }
      });
    });
    _this.resizeObserver.observe(document.getElementById("boxDiv"));
  },
  methods: {
    changeDeclarationNo(val) {
      console.log(val)
      let isSameDeclarationNoList = this.wmOrderForm.wmAppApmListDetailList.filter(item => item.declarationNo === val)
      if(isSameDeclarationNoList.length > 1) {
        this.$coreMethods.message("warning", `填写报关单号[${val}]相同，请核对！`);
      }
    },
    changeNegativeNumber(e){
      if(e.target.value.indexOf('-') !== -1) {
        this.$coreMethods.message("warning", "不允许填写负号");
        e.target.value = e.target.value.replace(/\-/,'')
      }
    },
    //关闭界面并返回上一级页面
    closeTab() {
      this.$store.state.tagsView.visitedViews.splice(
        this.$store.state.tagsView.visitedViews.findIndex(
          (item) => item.path === this.$route.path
        ),
        1
      );
      this.$router.push(
        this.$store.state.tagsView.visitedViews[
          this.$store.state.tagsView.visitedViews.length - 1
        ].path
      );
    },
    //获取数据字典
    //获取数据字典
    getSelectList() {
      let self = this;
      queryDictRows("MD_CODE_DICT$ACCOPY_STS,MD_CODE_DICT$MD_CODE_YESNO").then((res) => {
        /*name:value value:key*/
        console.log("queryDictRows:", res);
        //付款方式
        self.accopyStsList = res.MD_CODE_DICT$ACCOPY_STS;
        self.yesOrNoList = res.MD_CODE_DICT$MD_CODE_YESNO;
      });
    },
    //查询
    queryOrder() {
      let self = this;
      // self.wmOrderForm = {}
      // if((self.formData.deployPort === null || self.formData.deployPort === '') || self.formData.verificationCode === null)  return self.$coreMethods.message("warning", "请输入订单单号或验证码");
       if((self.formData.deployPort === null || self.formData.deployPort === ''))  return self.$coreMethods.message("warning", "请输入订单单号");
      queryWmOrderAppointment({
        orderNoParam: self.formData.deployPort,
        verificationCode: self.formData.verificationCode
      }).then((res) => {
        if (res.success) {
          if( res.wmOrderAppointment === null) return self.$coreMethods.message("error", "订单数据不存在，请确认");
          //执行
          self.wmOrderForm.vesselNameEn = res.wmOrderAppointment.vesselNameEn;
          self.wmOrderForm.isOverApmtDatePeroid = res.wmOrderAppointment.isOverApmtDatePeroid;
          self.wmOrderForm.voyage = res.wmOrderAppointment.voyage;
          self.wmOrderForm.orderNo = res.wmOrderAppointment.orderNo;
          self.wmOrderForm.isHazard = res.wmOrderAppointment.isHazard;
          self.yesOrNoList.forEach(item => {
							if(res.wmOrderAppointment.isHazard === item.key) {
								self.wmOrderForm.isHazardCn = item.value
							}
						})
          self.wmOrderForm.noOfPackage = res.wmOrderAppointment.noOfPackage;
          self.wmOrderForm.cube = res.wmOrderAppointment.cube;
          self.wmOrderForm.grossWeight = res.wmOrderAppointment.grossWeight;
          self.wmOrderForm.locationCode = res.wmOrderAppointment.locationCode;
          //查验预约信息

          if (res.wmOrderAppointment.wmAppApmtListDto === null) {
            self.wmOrderForm.wmAppApmtListDto = {
              accopySts: "ACC",
            };
          } else {
            self.wmOrderForm.wmAppApmtListDto =
            res.wmOrderAppointment.wmAppApmtListDto;
          }
          self.wmOrderForm.wmAppApmtListDto.wmOrderId =
              self.wmOrderForm.wmOrderId = res.wmOrderAppointment.wmOrderId;
          //查验预约信息报单列表
          self.wmOrderForm.wmAppApmListDetailList =
            res.wmOrderAppointment.wmAppApmListDetailList;
          if (
            Array.isArray(res.wmOrderAppointment.wmAppApmListDetailList) &&
            res.wmOrderAppointment.wmAppApmListDetailList.length > 0
          ) {
            self.wmOrderForm.wmAppApmListDetailList.forEach((item) => {
              delete item.lastModifyTime;
              delete item.createTime;
            });
          } else {
            self.wmOrderForm.wmAppApmListDetailList = [
              {
                declarationNo: "",
                otherNo: "",
                qty: "",
                weight: "",
                volume: "",
                lastModifyTime: "",
              },
            ];
          }

           self.appointmentDataList = res.wmOrderAppointment.apmtDateVoList
           self.$forceUpdate();
        }
      }).catch((error) => {
             const errorObj = JSON.parse(
                error.response.data.header.errorMessage.split("返回内容：")[1]
              );
              this.$coreMethods.message("error", errorObj.errorMessages[0]);
      })
    },
    deleteKey(data) {
      for (const key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }
    },
    //提交
    submitOrder() {
      let self = this;
      self.$refs.ruleFormRef.validate((valid) => {
        //校验成功，提交
        if (valid) {
          let declarationNoList =  this.wmOrderForm.wmAppApmListDetailList.map(item  => item.declarationNo);
           if([...new Set(declarationNoList)].length !== this.wmOrderForm.wmAppApmListDetailList.length) {

            let repeatArr = [];
            declarationNoList.concat().sort().sort(function(a,b) {
　　　　　　if(a==b && repeatArr.indexOf(a) === -1) repeatArr.push(a);
　　　　});
let temp = repeatArr.join(',')
 self.$coreMethods.message("warning", `填写报关单号[${temp}]相同，请核对！`);
            return
          }
          delete this.wmOrderForm.wmAppApmtListDto.apmtDate;
          let isAllDeclarationNo = self.wmOrderForm.wmAppApmListDetailList.every(item => item.declarationNo !== "" && item.declarationNo !== null)
          if(!isAllDeclarationNo) return self.$coreMethods.message("error", "请填写报关单号");

          let isAllNegativeNumber = false

          submitAppointment(this.wmOrderForm).then((res) => {
            console.log("submitAppointment", res);
            if (res.success) {
              self.$coreMethods.message("success", "提交成功");
              self.queryOrder();
            } else {
              self.$coreMethods.message("error", "提交失败");
            }
          }).catch(error => {
             const errorObj = JSON.parse(
                error.response.data.header.errorMessage.split("返回内容：")[1]
              );
              this.$coreMethods.message("error", errorObj.errorMessages[0]);
          })
        } else {
          self.$coreMethods.message("warning", "请检查必输字段！");
        }
      });
    },

    //重置搜索框
    resetForm() {
      this.formData = {};
    },

    boxInfoFn() {
      this.boxVisible = true;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        // this.$refs.boxInfoTableRef.resizeTo(containerWidth);
      });
    },

    boxDetailFn() {
      this.boxVisible = false;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.boxDetailTableRef.resizeTo(containerWidth);
      });
    },
    addWmAppApmListDetailList() {
      var wmAppApmListDetailItem = {
        declarationNo: "",
        otherNo: "",
        qty: "",
        weight: "",
        volume: "",
      };
      this.wmOrderForm.wmAppApmListDetailList.push(wmAppApmListDetailItem);
    },
    removeWmAppApmListDetailList(index) {
      this.wmOrderForm.wmAppApmListDetailList.splice(index, 1);
    },
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
};
</script>
<style>
.propsItem .el-form-item__label{
  color:red !important;
}
</style>
